import { useQueryDetails, useQueryClient, useReloadQuery } from '@gogame/query';

import { loadPartnerAudienceDetails } from 'scenes/CustomAudiences/PartnerAudiences/sources/partnerAudiences';

import { details, grids } from './queryKeyFactory';

export const useLoadPADetails = id => {
  const queryClient = useQueryClient();
  return useQueryDetails(
    details(id),
    () => loadPartnerAudienceDetails({ id }),
    {
      initialData: () => {
        return queryClient
          .getQueryData(grids(), { exact: false })
          ?.rows?.find(d => d.id === id);
      },
    }
  );
};

export const useReloadPADetails = id => useReloadQuery(details(id));
